import projectData from 'ProjectData/project'
import templateData from 'ProjectData/template'
import axios from 'axios'

const state = {
  environmenttextures: [],
  template: []
}

const getters = {
  getState (state) {
    return state
  }
}

const actions = {
  async fetchData ({ commit }, {sceneuid}) {
    let response = await axios
      .get(templateData)
    commit('setTemplate', response.data)

    response = await axios
      .get(projectData)
    const currentScene = response.data.scenes.find(sc => sc.sceneuid === sceneuid)
    commit('setState', currentScene)
  }
}

const mutations = {
  setState (state, data) {
    state.environmenttextures = data.environmenttextures
  },
  setTemplate (state, data) {
    state.template = data.template.environmenttextures
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
